/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { CreditCard } from '../model/creditCard';
import { EditCreditCard } from '../model/editCreditCard';
import { PortalUser } from '../model/portalUser';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class SavedCreditCardsApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public assignCreditCardObservable: CreditCard | undefined = undefined;

    /**
     * Assign CreditCard as Primary and/or to all memberships.
     * 
     * @param customerId 
* @param cardId 
* @param primary 
* @param membership 
     */
    @action
    public assignCreditCard(customerId: number, cardId: number, primary?: boolean, membership?: boolean, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<CreditCard> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling assignCreditCard.');
        }
        if (cardId === null || cardId === undefined) {
            throw new Error('Required parameter cardId was null or undefined when calling assignCreditCard.');
        }

        const queryParameters: {[index: string]: any} = {};
        if (primary !== undefined) {
            queryParameters['Primary'] = primary;
        }
        if (membership !== undefined) {
            queryParameters['Membership'] = membership;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.put<CreditCard>(
            `${this.basePath}/api/creditcards/${encodeURIComponent(String(customerId))}/${encodeURIComponent(String(cardId))}/assignments`,
            null,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.assignCreditCardObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public deleteCreditCardObservable: any = undefined;

    /**
     * Deletes credit card from user account with provided id.
     * 
     * @param customerId 
* @param cardId 
     */
    @action
    public deleteCreditCard(customerId: number, cardId: number, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling deleteCreditCard.');
        }
        if (cardId === null || cardId === undefined) {
            throw new Error('Required parameter cardId was null or undefined when calling deleteCreditCard.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.delete(
            `${this.basePath}/api/creditcards/${encodeURIComponent(String(customerId))}/${encodeURIComponent(String(cardId))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.deleteCreditCardObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public featureObservable: any = undefined;

    /**
     * Check if saved payments feature is enabled
     * 
          */
    @action
    public feature(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<any>(
            `${this.basePath}/api/creditcards/feature`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.featureObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public isEnabledObservable: Array<PortalUser> | undefined = undefined;

    /**
     * Check if saved payments feature is enabled for logged in user
     * 
          */
    @action
    public isEnabled(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<PortalUser>> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<PortalUser>>(
            `${this.basePath}/api/creditcards/enabled`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.isEnabledObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public saveCreditCardObservable: CreditCard | undefined = undefined;

    /**
     * Save/Edit credit card.
     * 
     * @param customerId 
* @param body 
     */
    @action
    public saveCreditCard(customerId: number, body?: EditCreditCard, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<CreditCard> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling saveCreditCard.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<CreditCard>(
            `${this.basePath}/api/creditcards/${encodeURIComponent(String(customerId))}`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.saveCreditCardObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public savedCreditCardsObservable: Array<CreditCard> | undefined = undefined;

    /**
     * Retrieves all saved credit cards for logged in user
     * 
     * @param customerId 
     */
    @action
    public savedCreditCards(customerId: number, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<CreditCard>> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling savedCreditCards.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<CreditCard>>(
            `${this.basePath}/api/creditcards/${encodeURIComponent(String(customerId))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.savedCreditCardsObservable = response.data);
            }
            return response;
        });
    }

}
